import ReservationBusinessDayType from "./ReservationBusinessDayType";

export default class ReservationBusinessDayTypeClass {
  constructor(private readonly _value: ReservationBusinessDayType = ReservationBusinessDayType.BUSINESS_DAY) {
  }

  get value() {
    return this._value;
  }
}